<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="white">
      <v-layout>
        <v-flex xs4 sm6 md4>
          <v-toolbar-title>Accepted status</v-toolbar-title>
        </v-flex>
        <v-flex xs4 sm6 md4>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            align="center"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 sm6 md4 text-xs-right v-if="indexData.totalTasks > 0">
          <v-btn color="indigo" outline round @click="resReport">
            Response Report
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <v-card>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Response Details</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Task Id
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.id }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Project Id
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.project_id }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Dasher Name
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.name }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Task Starting Time
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.started_at }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Task Completed Time
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.completed_at }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Task Accept At
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.accepted_at }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Task Accepted By
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.accepted_by }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Total Response Time
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ totalResponseTime }} Sec
                        </v-subheader>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Response Time Average
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ avgResTime }} Sec
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>

                <v-layout row>
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="indigo white--text">
                        <div class="headline">Question & Answer</div>
                      </v-card-title>
                      <v-card-text>
                        <div v-if="editedItem.project_type_id == 2">
                          <b>Task Accepted Location</b>
                          <br />
                          <span>
                            <b>Latitude:</b>
                            {{ editedItem.latitude }}
                          </span>
                          <br />
                          <span>
                            <b>Longitude:</b>
                            {{ editedItem.longitude }}
                          </span>
                        </div>
                        <div v-for="(ques, i) in editedItem.questions" :key="i">
                          <div>
                            <span>{{ i + 1 }}.</span>
                            <span
                              v-if="
                                editedItem.project_language == 1 ||
                                editedItem.project_language == 3
                              "
                            >
                              <span class="font-weight-bold">
                                Question Title English:
                              </span>
                              &nbsp;&nbsp;&nbsp;{{ ques.question }}
                              <span
                                class="red--text headline"
                                v-if="ques.required_optional == 1"
                              >
                                *
                              </span>
                            </span>
                            <br />
                            <span
                              class="font-weight-bold"
                              v-if="
                                editedItem.project_language == 2 ||
                                editedItem.project_language == 3
                              "
                            >
                              &nbsp;&nbsp;&nbsp;
                              <span class="font-weight-bold">
                                Question Title Bangla:
                              </span>
                              &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }}
                              <br />
                              <span
                                class="red--text headline"
                                v-if="ques.required_optional == 1"
                              >
                                *
                              </span>
                            </span>
                            <br>
                            <span><b>Question Type:</b> {{ ques.ui_category }} </span>
                          </div>
                          <span class="font-weight-bold">Answer:</span>
                          <!-- for image type -->
                          <div v-if="ques.ui_category_id == 9">
                            <div v-if="ques.multiple_answer == '1'">
                              <MultipleResponseView
                                :multipleData="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></MultipleResponseView>
                            </div>
                            <div v-else>
                              <v-img
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                height="150"
                                width="200"
                                :src="
                                  indexData.res_image +
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></v-img>
                              <div v-else>NULL</div>
                              <a
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :href="
                                  indexData.res_image +
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <!-- for audio type -->
                          <div v-else-if="ques.ui_category_id == 10">
                            <div v-if="ques.multiple_answer == '1'">
                              <MultipleResponseView
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :multipleData="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></MultipleResponseView>
                            </div>
                            <div v-else>
                              <audio
                                width="200"
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                controls
                              >
                                <source
                                  :src="
                                    indexData.res_audio +
                                    editedItem[
                                      getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    ]
                                  "
                                  type="audio/mp3"
                                />
                                Your browser does not support HTML audio.
                              </audio>
                              <br />
                              <a
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :href="
                                  indexData.res_audio +
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <!-- for video type -->
                          <div v-else-if="ques.ui_category_id == 11">
                            <div v-if="ques.multiple_answer == '1'">
                              <MultipleResponseView
                                :multipleData="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></MultipleResponseView>
                            </div>
                            <div v-else>
                              <video
                                width="200"
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                controls
                              >
                                <source
                                  :src="
                                    indexData.res_video +
                                    editedItem[
                                      getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    ]
                                  "
                                  type="video/mp4"
                                />
                                Your browser does not support HTML video.
                              </video>
                              <br />
                              <a
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :href="
                                  indexData.res_video +
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <!-- for contactInfo type -->
                          <div v-else-if="ques.ui_category_id == 15">
                            <div
                              v-if="
                                editedItem[
                                  getQuestionVariable(ques.question_sequence)
                                ]
                              "
                            >
                              <ContactInfoResponse
                                :contactForm="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              />
                            </div>
                          </div>
                          <!-- for multiple choice image -->
                          <div v-else-if="ques.ui_category_id == 14">
                            <div>
                              {{
                                showResponseForImageName(
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ],
                                  ques
                                )
                              }}
                            </div>
                            <div>
                              <v-img
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                height="150"
                                width="200"
                                :src="
                                  indexData.mul_choice_image +
                                  showResponseForImage(
                                    editedItem[
                                      getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    ],
                                    ques
                                  )
                                "
                              ></v-img>
                              <a
                                v-if="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                                :href="
                                  indexData.mul_choice_image +
                                  showResponseForImage(
                                    editedItem[
                                      getQuestionVariable(
                                        ques.question_sequence
                                      )
                                    ],
                                    ques
                                  )
                                "
                                target="_blank"
                              >
                                download
                              </a>
                            </div>
                          </div>
                          <div
                            v-else-if="
                              ques.ui_category_id == 1 ||
                              ques.ui_category_id == 2 ||
                              ques.ui_category_id == 4
                            "
                          >
                            <div v-if="ques.multiple_answer == '1'">
                              <div
                                v-for="(item, index1) in showMultipleResponse(
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ],
                                  ques
                                )"
                                :key="index1"
                              >
                                <li>{{ item }}</li>
                              </div>
                            </div>
                            <div v-else>
                              {{
                                showResponse(
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ],
                                  ques
                                )
                              }}
                            </div>
                          </div>
                          <!-- for open ended type -->
                          <div v-else>
                            <div v-if="ques.multiple_answer == '1'">
                              <MultipleResponseView
                                :multipleData="
                                  editedItem[
                                    getQuestionVariable(ques.question_sequence)
                                  ]
                                "
                              ></MultipleResponseView>
                            </div>
                            <div v-else>
                              {{
                                editedItem[
                                  getQuestionVariable(ques.question_sequence)
                                ]
                              }}
                            </div>
                          </div>
                          <span v-if="editedItem.time_expense">
                            <b>Time expense:</b>
                            {{
                              showResponseTime(
                                editedItem.time_expense,
                                ques.question_variable
                              )
                            }}
                          </span>
                          <br />
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="red" @click="close">Cancel</v-btn>
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
    <div v-if="alertMsg">
      <v-alert
        v-if="error == 0 && statusCode == 200"
        :value="true"
        type="success"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && statusCode == 204"
        :value="true"
        type="info"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
        :value="true"
        type="warning"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
      <v-alert
        v-if="error == 1 && statusCode == 500"
        :value="true"
        type="error"
        transition="slide-y-reverse-transition"
      >
        {{ errorMsg }}
      </v-alert>
    </div>
    <div v-if="isLoaded">
      <div v-if="indexData.totalTasks < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.dataStatus6.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.totalTasks > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.project_id }}</td>
          <td>{{ props.item.dasher_id }}</td>
          <td>{{ props.item.started_at }}</td>
          <td>{{ props.item.completed_at }}</td>
          <td>{{ props.item.accepted_at }}</td>
          <td>{{ props.item.accepted_by }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataStatus6.from }} -
          {{ indexData.dataStatus6.to }} of {{ indexData.dataStatus6.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.dataStatus6.current_page"
            :length="indexData.dataStatus6.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
      <v-spacer></v-spacer>
      <v-btn class="button" color="info" flat @click="download">Download</v-btn>
    </div>
  </div>
</template>

<script>
import MultipleResponseView from "./MultipleResponseView";
import ContactInfoResponse from "./ContactInfoResponse";
import { mapGetters } from "vuex";
import router from "../../router";

export default {
  components: {
    MultipleResponseView,
    ContactInfoResponse,
  },
  data: () => ({
    dialog: false,
    alertMsg: false,
    // apiUrl: 'change-status',
    routePath: "/pending",
    sl: 1,
    headers: [
      { text: "Task Id", align: "left", value: "id" },
      { text: "Project Id", align: "left", value: "project_id" },
      {
        text: "Task Submitted By",
        align: "left",
        sortable: false,
        value: "dasher_id",
      },
      { text: "Task starting time", value: "started_at" },
      { text: "Task Completion Time", value: "completed_at" },
      { text: "Task Accepted At", value: "accepted_at" },
      { text: "Task Accepted By", value: "accepted_by" },
      { text: "Actions", align: "center", value: "name", sortable: false },
    ],
    loading: false,
    search: "",
    pagination: {
      rowsPerPage: 10,
    },
    rowsPerPageItems: [10, 20, 50, 100, 200, 500],
    editedIndex: -1,
    editedItem: {
      time_expense: [],
      questions: [],
    },
    defaultItem: {},
    totalResponseTime: 0,
    avgResTime: 0,
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLoaded() {
      if (this.indexData.dataStatus6) {
        return true;
      } else {
        return false;
      }
    },
    // multipleRes: function(answer){
    //   console.log(answer)
    // }
  },

  watch: {
    pagination() {
      this.paginationMethod();
    },
    dialog(val) {
      val || this.close();
    },
  },

  // created () {
  //   this.initialize()
  // },

  methods: {
    initialize() {
      //  this.paginationMethod()
      let projectId = window.localStorage.getItem("projectId");
      this.$store.dispatch("changeTaskStatus", [
        "task-status",
        6,
        projectId,
        "",
        1,
        10,
      ]);

      this.alertMsg = true;
      setTimeout(() => {
        this.alertMsg = false;
      }, 300);
    },

    getQuestionVariable(questionSequence) {
      return "var" + questionSequence;
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    checkItem(item) {
      // console.log(item);
      if (this.indexData.dataStatus6) {
        this.editedIndex = this.indexData.dataStatus6.data.indexOf(item);
        this.editedItem = Object.assign({}, item);
        if (item.duration_json) {
          this.editedItem.time_expense = JSON.parse(item.duration_json);
        } else {
          this.editedItem.time_expense = null;
        }
        this.editedItem.questions = this.indexData.questions.data;

        var num_of_res = this.editedItem.time_expense.length;
        var response_time = 0;
        this.editedItem.time_expense.forEach((element) => {
          const arrayFailed = Object.entries(element).map((arr) => ({
            fieldName: arr[0],
            value: arr[1],
          }));
          response_time = response_time + parseInt(arrayFailed[0].value);
        });
        this.totalResponseTime = response_time;
        this.avgResTime = Math.round(response_time / num_of_res);
        this.dialog = true;
      }
    },
    showResponseForImage(value, question_data) {
      // console.log(value);
      return question_data.imageOptions[parseInt(value) - 1].url;
    },
    showResponseTime(time_array, question_data) {
      var response_time = "";
      time_array.forEach((element) => {
        const arrayFailed = Object.entries(element).map((arr) => ({
          fieldName: arr[0],
          message: arr[1],
        }));
        if (arrayFailed[0].fieldName == question_data) {
          response_time = arrayFailed[0].message + " Sec";
        }
      });
      return response_time;
    },
    showResponseForImageName(value, question_data) {
      return question_data.imageOptions[parseInt(value) - 1].title;
    },
    showResponse(value, question_data) {
      if (value) {
        var valueInt = parseInt(value);
        // console.log(parseInt(question_data.project_id));
        if (
          (isNaN(valueInt) || value.length > 2) &&
          parseInt(question_data.project_id) < 20
        ) {
          return value;
        }
        var return_title = "";
        if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 1
        ) {
          return question_data.options[valueInt - 1].title;
        } else if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 2
        ) {
          return question_data.bangla_options[valueInt - 1].title;
        } else if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 3
        ) {
          return (
            question_data.options[valueInt - 1].title +
            "(" +
            question_data.bangla_options[valueInt - 1].title +
            ")"
          );
        }
        return return_title;
      } else {
        return null;
      }
    },

    showMultipleResponse(value, question_data) {
      if (value) {
        var return_title = [];
        if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 1
        ) {
          value.split("|").forEach((element) => {
            if (
              (isNaN(parseInt(element)) || value.length > 2) &&
              question_data.project_id < 20
            ) {
              return_title.push(element);
            } else {
              return_title.push(
                question_data.options[parseInt(element) - 1].title
              );
            }
          });
        } else if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 2
        ) {
          value.split("|").forEach((element) => {
            if (
              (isNaN(parseInt(element)) || value.length > 2) &&
              question_data.project_id < 20
            ) {
              return_title.push(element);
            } else {
              return_title.push(
                question_data.bangla_options[parseInt(element) - 1].title
              );
            }
          });
        } else if (
          (question_data.ui_category_id == 1 ||
            question_data.ui_category_id == 2 ||
            question_data.ui_category_id == 4) &&
          this.editedItem.project_language == 3
        ) {
          value.split("|").forEach((element) => {
            if (
              (isNaN(parseInt(element)) || value.length > 2) &&
              question_data.project_id < 20
            ) {
              return_title.push(element);
            } else {
              return_title.push(
                question_data.options[parseInt(element) - 1].title +
                  "(" +
                  question_data.bangla_options[parseInt(element) - 1].title +
                  ")"
              );
            }
          });
        }
        // console.log(return_title);
        return return_title;
      } else {
        return ["NULL"];
      }
    },
    download() {
      // window.open(`http://local.ddbb.com/project-details-report-export/${this.projectId}`);
      window.open(this.indexData.excelUrl);
    },
    splitedList(row) {
      return row !== null ? row.split("|") : "";
    },

    close() {
      this.dialog = false;
      this.totalResponseTime = 0;
      this.avgResTime = 0;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    resReport() {
      router.push("/dasher-response-report");
    },

    onPageChange() {
      this.paginationMethod();
    },

    paginationMethod() {
      this.loading = true;
      let tableName = window.localStorage.getItem("projectId");
      // console.log(this.indexData.dataStatus6.current_page);
      if (this.search) {
        this.$store.dispatch("changeTaskStatus", [
          "task-status",
          6,
          tableName,
          this.search,
          this.indexData.dataStatus6.current_page,
          this.pagination.rowsPerPage,
        ]);
        this.loading = this.indexData.dataStatus6.data ? false : true;
        this.alertMsg = true;
        setTimeout(() => {
          this.alertMsg = false;
        }, 300);
      } else {
        this.$store.dispatch("changeTaskStatus", [
          "task-status",
          6,
          tableName,
          "",
          this.indexData.dataStatus6.current_page,
          this.pagination.rowsPerPage,
        ]);
        this.loading = !this.indexData.error ? false : true;
        this.alertMsg = true;
        setTimeout(() => {
          this.alertMsg = false;
        }, 300);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-progress-circular
  margin: 1rem

.imageResize
  width: auto
  height: auto
</style>
